import React from 'react';

import { Box } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import QuickSearchToolbar from '~/components/Vendors/SalesforceSurcharges/components/QuickSearchToolbar';

import { formatDateSlashes, sortByDate } from '~/services/TimeService';

import type { SalesforceBlackoutDate } from '../types';

interface Props {
  blackoutDates: Array<SalesforceBlackoutDate>;
  selectedBlackoutDates: Array<SalesforceBlackoutDate>;
  onSelectBlackoutDates: (sfids: Array<string | number>) => void;
}

export function BlackoutRecordSelection({ blackoutDates, selectedBlackoutDates, onSelectBlackoutDates }: Props) {
  const columns: Array<GridColDef<SalesforceBlackoutDate>> = [
    { field: 'name', headerName: 'Blackout name', minWidth: 220, flex: 1, display: 'flex' },
    {
      field: 'from__c',
      headerName: 'From',
      minWidth: 120,
      type: 'date',
      sortComparator: sortByDate,
      valueFormatter: (value) => formatDateSlashes(value),
      display: 'flex',
    },
    {
      field: 'to__c',
      headerName: 'To',
      minWidth: 120,
      type: 'date',
      sortComparator: sortByDate,
      valueFormatter: (value) => formatDateSlashes(value),
      display: 'flex',
    },
  ];

  return (
    <Box sx={{ height: '100%' }}>
      <DataGrid
        rows={blackoutDates}
        columns={columns}
        getRowId={(row) => row.sfid}
        density="compact"
        pageSizeOptions={[10]}
        sx={{
          minWidth: 650,
          height: '100%',
          '.MuiDataGrid-menuIcon': {
            width: 'auto',
            visibility: 'visible',
          },
          '.MuiDataGrid-iconButtonContainer': {
            visibility: 'visible',
            width: 'auto',
            '&:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
              opacity: 1,
            },
          },
        }}
        checkboxSelection
        onRowSelectionModelChange={(rowSelectionModel) => onSelectBlackoutDates([...rowSelectionModel])}
        rowSelectionModel={selectedBlackoutDates.map((blackoutDate) => blackoutDate.sfid)}
        slots={{ toolbar: QuickSearchToolbar }}
      />
    </Box>
  );
}
